module.exports = __webpack_public_path__ + "static/media/tanvi-nagpal.72594073.png";